import React, { Component } from 'react';
import PropTypes from "prop-types"
import styles from './userPermissionRemote.module.scss';
import classnames from 'classnames';
import { strings } from '../utils/translations';
import { Form, Radio, Button, Switch, TimePicker, DatePicker } from 'antd';
import Counter from '../Counter/counter';
import CloseIcon from '../../img/icons/closeIcon';
import UnlimitedIcon from '../../img/icons/unlimited-icon.svg';
import TemporalIcon from '../../img/icons/clock-icon.svg';
import RecurrentIcon from '../../img/icons/recurrent-icon.svg';
import DownOutlinedIcon from '../../img/icons/downOutlined-icon.svg';

import moment from "moment";
import API from '../utils/API';
import Alert from '../Alert/alert';
import PrimaryButton from '../Buttons/primaryButton';
import { notification, Popconfirm } from 'antd'
import { Utils } from '../utils/utils'

const { RangePicker } = DatePicker;
const timeFormat = 'HH:mm';
const dateFormat = 'YYYY/MM/DD'
const dateDisplayFormat = 'DD MMM YYYY'
const dateTimeDisplayFormat = 'DD/MM/YYYY HH:mm'


export default class UserPermissionRemote extends Component
{
    originalPermission = null

    constructor (props)
    {
        super(props)

        this.state =
        {
            validation: {
                state: '',
                message: ''
            },
            validationDays: {
                state: '',
                message: ''
            },
            edit: false,
            permissionFrequency: null,
            permission: {
                doorId: '',
                roleType: '',
                startDate: null,
                endDate: null,
                name: '',
                emailOrPhone: ''
            },
            user: {
                email: '',
                name: '',
                lastName: '',
                id: '',
            },
            modal: {
                endDateOpen: false,
                disabledEndHours: null,
                disabledEndMinutes: null,
                disabledStartHours: null,
                disabledStartMinutes: null,
                selectedDay: {
                    value: null,
                    name: null
                },
                markedDays: {
                    1: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    2: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    3: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    4: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    5: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    6: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    0: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    }
                },
                formFields: {
                    doorId: this.props.permission ? this.props.permission.id : null,
                    roleType: 'owner',
                    startDate: null,
                    endDate: null,
                    name: '',
                    emailOrPhone: ''
                }
            },
            closeCard: props.closeCard,
            showAlert: false,
            alertMessage: null,
            alertColor: null,
            roleType: props.roleType,
            
            isSending: false,
            showRevokeConfirmation: false
        }
    }

    componentDidMount()
    {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(props)
    {
        if (props.permission != null && JSON.stringify(props.permission).length > 2)
        {
            // Save the original permission to load it back when cancelling the edit mode
            if (this.originalPermission == null)
                this.originalPermission = Object.assign({}, props.permission)
            
            this.setStateFromOriginalPermission(props.permission)
        }
    }
    
    
    render()
    {
        let title = null
        let vrView = null
        
        let subscriptionType = this.state.permission?.assignedVirtualRemote?.subscription?.type
		let subscriptionStatus = this.state.permission?.assignedVirtualRemote?.subscription?.status
		let vrIcon = require('../../img/icons/remote_big_gray.svg').default
		let vrTitle = strings('vrPermissionTitleFree')
		let vrSubtitle = strings('vrPermisisonSubtitleNoRenewal')
		let vrSmallText = null
        let permissionPending = this.state.permission?.activationDate == null
        
        let { isExpired, isCancelled, isTrial, paymentAdded, isPastDue } = Utils.getVRisExpired(this.state.permission?.assignedVirtualRemote)
        
        if (this.state.permission.activationDate != null)
			title = (this.state.permission.user.lastName != null) ? this.state.permission.user.name + ' ' + this.state.permission.user.lastName : this.state.permission.user.name
		else
			title = this.state.permission.invitationData?.guestName
        
        if (subscriptionType === '1 year')
		{
			vrIcon  	= require('../../img/icons/remote_big_purple.svg').default
			vrTitle 	= strings('vrPermissionTitle1Year')
			vrSubtitle 	= (isCancelled) ? strings('vrPermisisonSubtitleManual') : strings('vrPermisisonSubtitleAuto')
			vrSmallText = (isCancelled) ? strings('vrPermissionsSmallTextManual') : strings('vrPermissionsSmallTextAuto')
		}
		else if (subscriptionType === '5 years')
		{
			vrIcon  	= require('../../img/icons/remote_big_gold.svg').default
			vrTitle 	= strings('vrPermissionTitle5Year')
			vrSubtitle 	= strings('vrPermisisonSubtitleManual')
			vrSmallText = strings('vrPermissionsSmallTextManual')
		}
        
        if (isTrial)
        {
            vrSubtitle = strings('trialMode')
            vrSmallText = (permissionPending ||
                           this.state.permission?.assignedVirtualRemote?.delegatedUser == null) ?
                                `${strings('vrPermissionsSmallTextTrial')} ${strings('vrPermissionsSmallTextTrial2')}` :
                                `${strings('vrPermissionsSmallTextTrial')} ${this.state.permission?.assignedVirtualRemote?.delegatedUser?.name} ${this.state.permission?.assignedVirtualRemote?.delegatedUser?.lastName} ${strings('vrPermissionsSmallTextTrial2')}`
                                
            if (paymentAdded)
					vrSmallText = strings('vrPermissionsSmallTextTrialPaymentAdded')
        }
        else if (isPastDue)
        {
            vrSubtitle = strings('pastDue')
            vrSmallText = strings('pastDueInfo')
        }
        
        if (isExpired)
        {
            vrSubtitle  = strings('expired')
            vrSmallText = (permissionPending ||
                           this.state.permission?.assignedVirtualRemote?.delegatedUser == null) ?
                                `${strings('vrPermissionsSmallTextExpired')} ${strings('vrPermissionsSmallTextExpired2')}` :
                                `${strings('vrPermissionsSmallTextExpired')} ${this.state.permission?.assignedVirtualRemote?.delegatedUser?.name} ${this.state.permission?.assignedVirtualRemote?.delegatedUser?.lastName} ${strings('vrPermissionsSmallTextExpired2')}`
        }
        
        
        return (
            <div className={styles.doorRemoteDetailBlock}>
                <div className={styles.topBarDetail}>
                    <div>
                        <span className={styles.label}>{ strings('permission') }</span>
                        <h3 className={styles.title}>{ title }</h3>
                    </div>
                    <div className={styles.iconsContainer}> 
                        <CloseIcon className={styles.closeIcon} size="12" onClick={() => this.close()} />
                    </div>
                </div>

                {
                    (this.state.permission.roleType !== 'admin') &&
                    <div className={styles.permissionTypeContent}>
                        <h3 className={styles.title}>{ strings('permissionType') }</h3>
                        <div className='permissionTypeOptions'>
                            <Radio.Group
                                defaultValue={ this.state.permission.roleType === 'admin' ? 'owner' : this.state.permission.roleType }
                                disabled={true}
                                onChange={this.onChangeTypeOption}
                                value={this.state.permission.roleType}
                            >
                                <div className='permissionTypeItem'>
                                    <Radio value={'owner'}>
                                        <div className='permissionTextBlock'>
                                            <p className='text'>{ strings('owner') }</p>
                                        </div>
                                    </Radio>
                                    <Radio value={'guest'}>
                                        <div className='permissionTextBlock'>
                                            <p className='text'>{ strings('guest') }</p>
                                        </div>
                                    </Radio>
                                </div>
                            </Radio.Group>
                        </div>
                    </div>
                }
                
                {
                    (this.state.permission.roleType === 'owner') ? null
                        /*<div className={styles.permissionFrecuencyContent}>
                            <h3 className={styles.title}>{ strings('extraRemotes') }</h3>
                            <Counter
                                disabledMin={ true }
                                disabledMax={ true }
                                number={ (this.state.permission.activationDate == null) ?
                                          this.state.permission.permissionsToGrant
                                          : this.state.permission.virtualRemotes.owned.length
                                        }
                                action={ (e) => this.permissionCount(e) }
                            />
                            <div className={styles.smallTextDescription}><code>{ strings('extraRemotesDescription') }</code></div>
                        </div>*/
                        :
                        (this.state.permission.roleType === 'guest' && this.state.permissionFrequency) ?
                        <>
                            <div className={styles.permissionFrecuencyContent}>
                                <h3 className={styles.title}>{ strings('permissionFrequency') }</h3>
                                <div className='permissionTypeOptions'>
                                    <div className='permissionTypeItem frecuencyTypeItem'>
                                        <div className='inputBox'>
                                            <img className={styles.icon} src={UnlimitedIcon} alt="Permiso ilimitado" />
                                        </div>
                                        <div className='permissionTextBlock'>
                                            <p className='text'>Permiso Ilimitado</p>
                                            <Switch
                                                className='switcher'
                                                onClick={ () => this.permissionDurationType("unlimited") }
                                                disabled={true}
                                                checked={ (this.state.permissionFrequency === 'unlimited' ) ? true : false}
                                            />
                                        </div>
                                    </div>
                                    <div className='permissionTypeItem frecuencyTypeItem'>
                                        <div className='inputBox'>
                                            <img className={styles.icon} src={TemporalIcon} alt="Permiso Temporal" />
                                        </div>
                                        <div className='permissionTextBlock'>
                                            <p className='text'>Permiso Temporal</p>
                                            <Switch
                                                className='switcher'
                                                onClick={ () => this.permissionDurationType("temporary") }
                                                disabled={true}
                                                checked={ (this.state.permissionFrequency === 'temporary' ) ? true : false}
                                            />
                                        </div>
                                    </div>
                                    <div className='permissionTypeItem frecuencyTypeItem'>
                                        <div className='inputBox'>
                                            <img className={styles.icon} src={RecurrentIcon} alt="Permiso Recurrente" />
                                        </div>
                                        <div className='permissionTextBlock'>
                                            <p className='text'>Permiso Recurrente</p>
                                            <Switch
                                                className='switcher'
                                                onClick={ () => this.permissionDurationType("recurrent") }
                                                disabled={true}
                                                checked={ (this.state.permissionFrequency === 'recurrent' ) ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                this.durationRender()
                            }
                        </>
                        :
                        null
                }
                
                {
                    <div className={styles.vrSection}>
                        <h3 className={styles.title}>{ strings('virtualRemote') }</h3>
                        
                        <div className='permissionTypeOptions'>
                        {
                            (this.state.permission?.assignedVirtualRemote != null) ?
                            <>
                                <div className={styles.vrTopView}>
                                    <img className={styles.vrIcon} src={vrIcon} />
                                    <div>
                                        <div className={styles.vrTitle}>{ vrTitle }</div>
                                        <div className={styles.vrSubtitle}>
                                            {
                                                (isTrial || isExpired || isPastDue) ?
                                                <div className={styles.orange}>
                                                    { vrSubtitle }
                                                </div>
                                                : vrSubtitle
                                            }
                                        </div>
                                    </div>
                                </div>
                                {
                                    (subscriptionType === '1 year' ||
                                    subscriptionType === '5 years') &&
                                    <>
                                        <div className={styles.vrDataRow}>
                                            <div className={styles.vrDataRowTitle}>{ strings('expires') }</div>
                                            <div className={styles.vrDataRowData}>{ moment(this.state.permission?.assignedVirtualRemote?.expireDate).format('LL, HH:mm') }</div>
                                        </div>
                                        {
                                            (subscriptionType === '1 year' ||
                                            subscriptionType === '5 years') &&
                                            <div className={styles.vrDataRow}>
                                                <div className={styles.vrDataRowTitle}>{ strings('payedBy') }</div>
                                                <div className={styles.vrDataRowData}>
                                                    {
                                                        (permissionPending && isTrial) ?
    													'-'
    													:
                                                        <>
                                                            { `${this.state.permission?.assignedVirtualRemote?.delegatedUser?.name} ${this.state.permission?.assignedVirtualRemote?.delegatedUser?.lastName}` }
                                                            {((this.state.permission?.assignedVirtualRemote?.delegatedUserId == API.getInstance().getUserId()) &&
                                                            ` (${strings('me')})`)}
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </>
                            :
                            <div className={styles.vrNoRemote}>
                                <div className={styles.vrNoRemoteTitle}>{ strings('vrPermissionsNoRemoteTitle') }</div>
                                <div className={styles.vrNoRemote}>{ strings('vrPermissionsNoRemote') }</div>
                            </div>
                        }
                        </div>
                        
                        {
							(this.state.permission?.assignedVirtualRemote != null) &&
							<div className={classnames(styles.smallTextDescription, styles.vrSmallText)}>
                                <code>
								{
									(isTrial || isExpired || isPastDue) ?
									<div className={styles.orange}>
										{ vrSmallText }
									</div>
									: vrSmallText
								}
                                </code>
							</div>
						}
                    </div>
                }
                
                
                {
                    (this.state.roleType !== 'guest') &&
                    <>
                        {
                            ((this.state.permission.activationDate == null ||
                              this.state.permission.user?.id != API.getInstance().getUserId()) &&
                             (this.state.permission.roleType === 'guest' ||
                              this.state.permission.roleType === 'owner')) &&
                            <div className={styles.footerBtnsContainer}>
                                <div className={styles.footerButtons}>
                                    {
                                        (this.state.permission.activationDate == null) &&
                                        <Button
                                            block
                                            type="text"
                                            size="large"
                                            style={{marginBottom: 8}}
                                            onClick={() => this.copyInvitationLink()}
                                        >
                                            { strings('copyInvitationLink') }
                                        </Button>
                                    }
                                    
                                    <Popconfirm
                                      title={strings('revokePermissionConfirmation')}
                                      visible={this.state.showRevokeConfirmation}
                                      onConfirm={() => this.revokePermission(this.state.permission.id)}
                                      onCancel={() => this.setState({ showRevokeConfirmation: false })}
                                      cancelText={strings('cancel')}
                                      okText={strings('revokePermissionConfirmationOk')}
                                      okButtonProps={{ danger: true, size: 'medium', loading: this.state.isSending }}
                                      cancelButtonProps={{ size: 'medium' }}
                                    >
                                        <div
                                            className={styles.deleteLink}
                                            onClick={() => this.setState({ showRevokeConfirmation: true })}
                                        >
                                            { strings('deletePermission') }
                                        </div>
                                    </Popconfirm>
                                </div>
                            </div>
                        }
                    </>
                }
            </div>
        )
    }


    setStateFromOriginalPermission(originalPermission)
    {
        let modal = this.state.modal
        let permissionFrequency

        this.setState({
            permission: {},
            permissionFrequency: null,
            edit: false
        }, () =>
        {
            let permission = Object.assign({}, originalPermission)

            if (permission.PermissionDays && permission.PermissionDays.length)
            {
                permissionFrequency = 'recurrent'

                permission.PermissionDays.forEach(item =>
                {
                    modal.markedDays[item.dayOfWeek].set = true

                    if (item.endTime && item.startTime)
                    {
                        modal.markedDays[item.dayOfWeek].startTime = item.startTime
                        modal.markedDays[item.dayOfWeek].endTime = item.endTime
                    }
                    else
                    {
                        modal.markedDays[item.dayOfWeek].allDay = true
                    }
                })
            }
            else if (permission.startDate)
                permissionFrequency = 'temporary'
            else if (permission.roleType)
                permissionFrequency = 'unlimited'

            this.setState({
                permission,
                permissionFrequency,
                modal
            })
        })
    }

    permissionTypeChange(e)
    {
        if (this.state.edit)
        {
            let permission = this.state.permission
            permission.roleType = e.target.value

            this.setState({ permission })
            this.validationReset()
        }
    }

    onChangeTypeOption = e => {
        let permission = this.state.permission
        permission.roleType = e.target.value

        this.setState({ permission })
        this.validationReset()
    };

    permissionDurationType(value)
    {
        let newPermissionFrequency = value
        let permission = this.state.permission

        if (newPermissionFrequency === 'temporary')
        {
            if (permission.startDate == null)
                permission.startDate = moment().toISOString()
        }

        if (newPermissionFrequency === 'unlimited')
        {
            permission.startDate = null
            permission.endDate = null
        }

        this.setState({ permissionFrequency: newPermissionFrequency, permission })
    }

    toggleDay(val, name)
    {
        let modal = this.state.modal

        Object.keys(modal.markedDays).forEach((key) => {
            modal.markedDays[key].selected = false
        })

        modal.markedDays[val].selected = true

        modal.selectedDay.name = name
        modal.selectedDay.value = val

        modal.disabledEndHours = modal.disabledEndMinutes = modal.disabledStartHours = modal.disabledStartMinutes = null

        this.setState({
            modal
        })
    }

    checkIfDaySelected()
    {
        let days = this.state.modal.markedDays
        return days[1].selected ||
            days[2].selected ||
            days[3].selected ||
            days[4].selected ||
            days[5].selected ||
            days[6].selected ||
            days[0].selected
    }

    checkAllDay()
    {
        let modal = this.state.modal

        modal.markedDays[this.state.modal.selectedDay.value].allDay
            = modal.markedDays[this.state.modal.selectedDay.value].set = !modal.markedDays[this.state.modal.selectedDay.value].set

        modal.markedDays[this.state.modal.selectedDay.value].startTime = modal.markedDays[this.state.modal.selectedDay.value].endTime = null

        this.setState({
            modal
        })
        this.validationDaysReset()
    }

    deleteDay()
    {
        let modal = this.state.modal

        modal.markedDays[modal.selectedDay.value] = {
            set: false,
            selected: false,
            allDay: false,
            startTime: null,
            endTime: null
        }
        modal.selectedDay = {
            value: null,
            name: null
        }

        this.setState({
            modal
        })
    }

    disabledHours(time)
    {
        let disabled = []

        if (this.state.modal.disabledEndHours && time === 'end') {
            for (
                let i=0;
                i < this.state.modal.disabledEndHours + (this.state.modal.disabledEndMinutes === 59 ? 1 : 0);
                i++
            ) {
                disabled.push(i)
            }
        }

        else if (time === 'start' &&  this.state.modal.disabledStartHours) {
            for (
                let i = this.state.modal.disabledStartHours + 1;
                i < 24;
                i++
            ) {
                disabled.push(i)
            }
        }

        return disabled
    }

    disabledMinutes(time)
    {
        let disabled = []

        if (this.state.modal.disabledStartHours === this.state.modal.disabledEndHours) {
            if (time === 'end' && this.state.modal.disabledEndMinutes) {
                for (
                    let i = 0;
                    i < this.state.modal.disabledEndMinutes + 1;
                    i++
                ) {
                    disabled.push(i)
                }
            }
            else if (time === 'start' && this.state.modal.disabledStartMinutes) {
                for (
                    let i = this.state.modal.disabledStartMinutes;
                    i < 60;
                    i++
                ) {
                    disabled.push(i)
                }
            }

        }

        return disabled
    }

    setDisabled(moment, time)
    {
        let modal = this.state.modal

        let hour = moment ? parseInt(moment.format("HH")) : null
        let min = moment ? parseInt(moment.format("mm")) : null

        if (time === 'start') {
            modal.disabledEndHours = hour
            modal.disabledEndMinutes = min
            modal.markedDays[this.state.modal.selectedDay.value].startTime = (hour * 60) + min

            if (modal.markedDays[this.state.modal.selectedDay.value].startTime
                && modal.markedDays[this.state.modal.selectedDay.value].startTime > modal.markedDays[this.state.modal.selectedDay.value].endTime) {
                modal.markedDays[this.state.modal.selectedDay.value].endTime = null
            }
        } else {
            modal.disabledStartHours = hour
            modal.disabledStartMinutes = min
            modal.markedDays[this.state.modal.selectedDay.value].endTime = (hour * 60) + min

            if (modal.markedDays[this.state.modal.selectedDay.value].endTime
                && modal.markedDays[this.state.modal.selectedDay.value].endTime < modal.markedDays[this.state.modal.selectedDay.value].startTime) {
                modal.markedDays[this.state.modal.selectedDay.value].startTime = null
            }
        }

        modal.markedDays[this.state.modal.selectedDay.value].set = !!(modal.markedDays[this.state.modal.selectedDay.value].endTime && modal.markedDays[this.state.modal.selectedDay.value].startTime)

        this.setState({
            modal
        })

        if (modal.markedDays[this.state.modal.selectedDay.value].endTime && modal.markedDays[this.state.modal.selectedDay.value].startTime) {
            this.validationDaysReset()
        }
    }

    durationRender()
    {
        let duration = this.state.permissionFrequency
        let daysOfTheWeek = [
            {
                value: 1,
                shortName: strings('mondayShort'),
                longName: strings('monday')
            },
            {
                value: 2,
                shortName: strings('tuesdayShort'),
                longName: strings('tuesday')
            },
            {
                value: 3,
                shortName: strings('wednesdayShort'),
                longName: strings('wednesday')
            },
            {
                value: 4,
                shortName: strings('thursdayShort'),
                longName: strings('thursday')
            },
            {
                value: 5,
                shortName: strings('fridayShort'),
                longName: strings('friday')
            },
            {
                value: 6,
                shortName: strings('saturdayShort'),
                longName: strings('saturday')
            },
            {
                value: 0,
                shortName: strings('sundayShort'),
                longName: strings('sunday')
            }
        ]

        if (duration === 'unlimited')
        {
            return null
        }
        else if (duration === 'temporary')
        {
            return (
                <>
                    {
                        this.dateRangePick()
                    }
                </>
            )
        }
        else
        {
            return (
            <div className={ classnames(styles.permissionTypeContent, styles.daysPermissions) }>
                <div className={styles.title}>{ strings('permissionDays') }</div>

                <div className={styles.daysOfTheWeekContainer}>
                    {
                        daysOfTheWeek.map((day, i) =>
                        {
                            return (
                                <div key={ i } className='daysOfTheWeek'>
                                    <Button
                                        type={ this.state.modal.markedDays[day.value].selected ? 'primary' : 'default' }
                                        shape="circle"
                                        onClick={ () => this.toggleDay(day.value, day.longName)}
                                    >
                                        <span className={ this.state.modal.markedDays[day.value].set ? 'selected' : null }>
                                            { day.shortName }
                                        </span>
                                    </Button>
                                    <div className={classnames('dot', { set: this.state.modal.markedDays[day.value].set })} />
                                </div>)
                        })
                    }
                </div>

                {
                    this.checkIfDaySelected() ?
                        <div className={styles.permissionDay}>
                            <div className={styles.topDayCard}>
                                <div className={styles.title}>
                                    { this.state.modal.selectedDay.name }
                                </div>
                            </div>

                            <div className={styles.dayCard}>
                                <div className={classnames('permissionTextBlock', styles.allDay)}>
                                    <div className='text'>Todo el día</div>
                                    <Switch
                                        checked={ this.state.modal.markedDays[this.state.modal.selectedDay.value].allDay }
                                        onChange={ () => this.checkAllDay() }
                                        disabled={true}
                                        className='switcher'
                                    />
                                </div>
                                {
                                    !this.state.modal.markedDays[this.state.modal.selectedDay.value].allDay ?
                                        <>
                                            <div className={styles.separator}></div>
                                        
                                            <div className={styles.fromTo}>
                                                <div className='fromToContent'>
                                                    <div className={styles.label}>{ strings('from') }</div>
                                                    <p className='text'>
                                                        {this.state.modal.markedDays[this.state.modal.selectedDay.value].startTime ?
                                                            moment(UserPermissionRemote
                                                                .getTime(this.state.modal.markedDays[this.state.modal.selectedDay.value].startTime),
                                                                    timeFormat)
                                                                .format(timeFormat)
                                                            : "-"
                                                        }
                                                    </p>
                                                </div>
                                                <div className='fromToContent'>
                                                    <div className={styles.label}>{ strings('to') }</div>
                                                    <p className='text'>
                                                        {this.state.modal.markedDays[this.state.modal.selectedDay.value].endTime ?
                                                            moment(UserPermissionRemote
                                                                .getTime(this.state.modal.markedDays[this.state.modal.selectedDay.value].endTime),
                                                                    timeFormat)
                                                                .format(timeFormat)
                                                            : "-"
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        null
                                }
                            </div>
                        </div>
                        :
                        null
                }
                <div className='startEndingBlock'>
                    <div className='starting'>
                        <div className='title'>Inicio del permiso</div>
                        <p className='text'>{moment(this.state.permission.startDate).format(dateDisplayFormat)}</p>
                    </div>
                    <div className='ending'>
                        <div className='title'>Fin del permiso</div>
                        <p className='text'>{moment(this.state.permission.endDate).format(dateDisplayFormat)}</p>
                    </div>
                </div>
            </div>
            )
        }
    }

    onDateChange = (field, value) =>
    {
        let permission = this.state.permission

        if (value != null)
        {
            permission[field] = value.toISOString()

            if (permission.endDate &&
                permission.startDate &&
                (moment(permission.endDate).diff(moment(permission.startDate), 'days') < 0))
            {
                if (field === 'startDate')
                    permission.endDate = null
                else
                    permission.startDate = null
            }
        }
        else
        {
            permission[field] = value;
        }

        this.setState({ permission })
        if (field === 'startDate') {
            this.validationReset()
        }
    }

    static getTime (val) {
        return `${val/60} : ${val%60}`
    }

    calendarChange(days)
    {
        let permission = this.state.permission

        permission.startDate    = days[0] ? days[0].toISOString() : null
        permission.endDate      = days[1] ? days[1].toISOString() : null

        this.setState({ permission })
        this.validationReset()
    }

    dateRangePick()
    {
        return (
            <div className={ classnames(styles.permissionTypeContent, styles.temporaryPermission) }>
                <div>
                    <div className={styles.title}>{ strings('from') }</div>
                    <div className={styles.temporaryDates}>
                        <div className='fromToContent temporary'>
                                <p className='text'>{moment(this.state.permission.startDate).format(dateTimeDisplayFormat)}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div className={styles.title}>{ strings('to') }</div>
                    <div className={styles.temporaryDates}>
                        <div className='fromToContent temporary'>
                                <p className='text'>{moment(this.state.permission.endDate).format(dateTimeDisplayFormat)}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    validationReset()
    {
        this.setState({
            validation: {
                state: '',
                message: ''
            }
        })
    }

    validationDaysReset()
    {
        this.setState({
            validationDays: {
                state: '',
                message: ''
            }
        })
    }

    validation(permission)
    {
        if (permission.roleType === 'guest')
        {

            if (this.state.permissionFrequency === 'temporary' && (!permission.startDate || !permission.endDate)) {
                this.setState({
                    validation: {
                        state: 'error',
                        message: 'Select date range'
                    }
                })
                return false
            }

            if (this.state.permissionFrequency === 'recurrent' && !permission.startDate) {
                this.setState({
                    validation: {
                        state: 'error',
                        message: 'Select start date'
                    }
                })
                return false
            }

            if (this.state.permissionFrequency === 'recurrent' && !this.checkSelectedDays()) {
                this.setState({
                    validationDays: {
                        state: 'error',
                        message: 'Select a day and set start, end times or check all day'
                    }
                })
                return false
            }

        }

        return true
    }

    checkSelectedDays()
    {
        let modal = this.state.modal
        let selected = false

        Object.keys(modal.markedDays).some(i =>
        {
            if (!selected && modal.markedDays[i].set)
            {
                selected = true
            }

            return true;
        })

        return selected
    }

    savePermission()
    {
        let modal = this.state.modal
        let permission = {...this.state.permission}

        delete permission.PermissionDays

        if (permission.roleType === 'guest')
        {
            permission.permissionsToGrant = 0;

            if (this.state.permissionFrequency === 'recurrent')
            {
                permission.permissionDays = []

                Object.keys(modal.markedDays).forEach(i =>
                {
                    if (modal.markedDays[i].set)
                    {
                        permission.permissionDays.push(
                            {
                                dayOfWeek: parseInt(i),
                                startTime: modal.markedDays[i].startTime,
                                endTime: modal.markedDays[i].endTime
                            })
                    }
                })
            }
                else if (this.state.permissionFrequency === 'temporary')
            {
                permission.startDate = this.state.permission.startDate;
                permission.endDate = this.state.permission.endDate;
            }
        }
        else
        {
            permission.startDate = null
            permission.endDate = null
        }

        permission.guestEmail = this.props.permission.user.email;
        permission.guestName = this.props.permission.user.name;

        if (this.state.permission.endDate != null ||
            this.state.permission.permissionDays.length != 0)
            this.grantPermission(permission);
    }

    grantPermission(data)
	{
        var t = API.getInstance().getToken()

        API.getInstance().grantPermission(data)
        .then(response =>
        {
            if (response.status == 200)
            {
                this.setState({
                    showAlert: true,
                    alertMessage: 'Permiso concedido exitosamente',
                    alertColor: 'green'
                })
            }
            else
            {
                this.setState({
                    showAlert: true,
                    alertMessage: 'There was an error updating the permission',
                })
            }
        })
        .catch(error =>
        {
            console.log(error);

            let errorMessage = strings('grantPermissionError');
            if (error && error.response && error.response.status === 409)
            {
                errorMessage = strings('permissionAlreadyGranted')
            }
            else
            {
                errorMessage = error.message;
            }
            this.setState({
                showAlert: true,
                alertMessage: errorMessage,
            })
        });
    }

    close(refreshPermissions)
	{
        this.props.closeCard(refreshPermissions)
    }

    revokePermission(permissionId)
	{
        this.setState({ isSending: true })
        
        API.getInstance().revokePermission(permissionId)
		.then(response =>
		{
			if (response.data.permissionRevoked)
			{
                this.setState({ showRevokeConfirmation: false })
                
                this.setStateFromOriginalPermission(this.originalPermission)
                
                notification.success(
                {
                    message: strings('revokePermissionSuccess'),
                    placement: 'topRight',
                    closeIcon: <></>
                })
                
                this.close(true)
			}
			else
			{    
                notification.error(
                {
                    message: 'Error',
                    description: strings('revokePermissionError'),
                    placement: 'topRight'
                })
			}
            
            this.setState({ isSending: false })
            
            if (this.props.onDeletePermission)
                this.props.onDeletePermission()
		})
		.catch(error =>
		{
			console.log(error);
            
            notification.error(
            {
                message: 'Error',
                description: strings('revokePermissionError'),
                placement: 'topRight'
            })
            
            this.setState({ isSending: false })
		});
    }

    permissionCount(val)
    {
        let permission = this.state.permission

        permission.permissionsToGrant += val

        this.setState({
            permission
        })
    }
    
    copyInvitationLink()
    {
        navigator.clipboard.writeText(`https://homyhub.com/activate-virtual-remote?permissionId=${this.state.permission.id}&token=${this.state.permission.token}`)
        
        notification.success(
        {
            message: strings('linkCopiedSuccessfully'),
            placement: 'top'
        })
    }
}

UserPermissionRemote.propTypes =
{
    permission: PropTypes.object,
    onClose: PropTypes.func,
    reload: PropTypes.func,
    editable: PropTypes.bool
}

UserPermissionRemote.defaultProps =
{
    reload: () => {},
    editable: true
}